import { create } from 'zustand';
import { EMPTY_FILTER_STATE, type FilterState } from '@bastion/list-view';

interface EpisodeFiltersState {
  /** Canonical list-view filter chips */
  filters: FilterState;
  /** Current pagination page (1-indexed) */
  currentPage: number;

  /** Replace filter state (resets page to 1) */
  setFilters: (next: FilterState) => void;
  /** Reset all filters to defaults */
  resetFilters: () => void;
  /** Set current pagination page */
  setCurrentPage: (page: number) => void;
}

export const useEpisodeFiltersStore = create<EpisodeFiltersState>((set) => ({
  filters: EMPTY_FILTER_STATE,
  currentPage: 1,

  setFilters: (next) => set({ filters: next, currentPage: 1 }),

  resetFilters: () => set({ filters: EMPTY_FILTER_STATE, currentPage: 1 }),

  setCurrentPage: (page) => set({ currentPage: page }),
}));
